import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shangchuan",
  "use": "icon-shangchuan-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-shangchuan\"><defs><style type=\"text/css\"></style></defs><path d=\"M187.904 664.192v140.992h648.192v-140.992H928v230.72H94.08l1.92-230.72h91.904z m332.928-536l142.72 227.84H556.864v328.256H465.024v-328.32H358.208l143.68-227.84h18.944z\" p-id=\"8859\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol